import { useEffect } from 'react';

export function useDocumentTitle(parts: (string | null)[]) {
  useEffect(() => {
    let title = '';

    parts.forEach((part) => {
      if (part) {
        title += `${part} | `;
      }
    });

    document.title = `${title}FollowAthletics`;
  }, [parts]);
}
